import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Social from '../section-components/social';
import LanguageContext from '../../i18n/LanguageContext';

// Emoji bayraklar Windows'ta harf koduna (TR/GB) dönüştüğü için SVG kullanılıyor.
const TrFlag = () => (
	<svg viewBox="0 0 30 20" width="20" height="14" aria-hidden="true">
		<rect width="30" height="20" fill="#E30A17" />
		<circle cx="12" cy="10" r="5" fill="#fff" />
		<circle cx="13.3" cy="10" r="4" fill="#E30A17" />
		<path d="M16.3,10 L20.2,8.8 L17.6,12 L17.6,8 L20.2,11.2 Z" fill="#fff" />
	</svg>
);
const GbFlag = () => (
	<svg viewBox="0 0 30 20" width="20" height="14" aria-hidden="true">
		<rect width="30" height="20" fill="#012169" />
		<path d="M0,0 L30,20 M30,0 L0,20" stroke="#fff" strokeWidth="3.2" />
		<path d="M0,0 L30,20 M30,0 L0,20" stroke="#C8102E" strokeWidth="1.1" />
		<path d="M15,0 V20 M0,10 H30" stroke="#fff" strokeWidth="5.4" />
		<path d="M15,0 V20 M0,10 H30" stroke="#C8102E" strokeWidth="3.2" />
	</svg>
);

class NavbarV2 extends Component {

    render() {
        const { t, lang, setLang } = this.context;
        let publicUrl = process.env.PUBLIC_URL+'/'
		let CustomClass = this.props.CustomClass ? this.props.CustomClass : ''
        return (
			<div>
				<header className={"ltn__header-area ltn__header-5 ltn__header-logo-and-mobile-menu-in-mobile ltn__header-logo-and-mobile-menu ltn__header-transparent--- gradient-color-4--- "+ CustomClass}>
				{/* ltn__header-top-area start */}
				<div className="ltn__header-top-area d-none">
					<div className="container">
					<div className="row">
						<div className="col-md-7">
						<div className="ltn__top-bar-menu">
							<ul>
							<li><a href="mailto:info@webmail.com?Subject=Flower%20greetings%20to%20you"><i className="icon-mail" /> info@webmail.com</a></li>
							<li><a href="locations.html"><i className="icon-placeholder" /> 15/A, Nest Tower, NYC</a></li>
							</ul>
						</div>
						</div>
						<div className="col-md-5">
						<div className="top-bar-right text-end">
							<div className="ltn__top-bar-menu">
							<ul>
								<li>
								{/* ltn__language-menu */}
								<div className="ltn__drop-menu ltn__currency-menu ltn__language-menu">
									<ul>
									<li><a href="#" className="dropdown-toggle"><span className="active-currency">English</span></a>
										<ul>
											<li><Link to="#">Arabic</Link></li>
											<li><Link to="#">Bengali</Link></li>
											<li><Link to="#">Chinese</Link></li>
											<li><Link to="#">English</Link></li>
											<li><Link to="#">French</Link></li>
											<li><Link to="#">Hindi</Link></li>
										</ul>
									</li>
									</ul>
								</div>
								</li>
								<li>
								<Social />
								</li>
							</ul>
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>
				{/* ltn__header-top-area end */}
				{/* ltn__header-middle-area start */}
				<div className="ltn__header-middle-area ltn__header-sticky ltn__sticky-bg-white">
					<div className="container">
					<div className="row">
						<div className="col">
						<div className="site-logo-wrap">
							<div className="site-logo go-top">
							<Link to="/"><img src={publicUrl+"assets/img/logo.png"} alt="Logo" /></Link>
							</div>
							<div className="get-support clearfix d-none">
							<div className="get-support-icon">
								<i className="icon-call" />
							</div>
							<div className="get-support-info">
								<h6>Get Support</h6>
								<h4><a href="tel:+123456789">123-456-789-10</a></h4>
							</div>
							</div>
						</div>
						</div>
						<div className="col header-menu-column">
						<div className="header-menu d-none d-xl-block go-top">
							<nav>
							<div className="ltn__main-menu">
								<ul>
								<li className=""><Link to="/">{t('nav.home')}</Link></li>
								<li className=""><Link to="/about">{t('nav.about')}</Link></li>
								<li className=""><Link to="/portfolio">{t('nav.photos')}</Link></li>
								<li className=""><Link to="/portfoliov">{t('nav.videos')}</Link></li>
								<li><Link to="/contact">{t('nav.contact')}</Link></li>
								<li className="special-link"><a href="https://api.whatsapp.com/send?phone=905520721972">{t('nav.reserve')}</a></li>

								</ul>
							</div>
							</nav>
						</div>
						</div>
						<div className="col--- ltn__header-options ltn__header-options-2 ">
						{/* Mobile Menu Button */}
						<div className="mobile-menu-toggle d-xl-none">
							<a href="#ltn__utilize-mobile-menu" className="ltn__utilize-toggle">
							<svg viewBox="0 0 800 600">
								<path d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200" id="top" />
								<path d="M300,320 L540,320" id="middle" />
								<path d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190" id="bottom" transform="translate(480, 320) scale(1, -1) translate(-480, -318) " />
							</svg>
							</a>
						</div>
						{/* Language Switcher (flags) */}
						<div className="roomy-lang-flags">
							<button
								type="button"
								className={lang === 'tr' ? 'active' : ''}
								onClick={() => setLang('tr')}
								aria-label="Türkçe" title="Türkçe">
								<TrFlag />
							</button>
							<button
								type="button"
								className={lang === 'en' ? 'active' : ''}
								onClick={() => setLang('en')}
								aria-label="English" title="English">
								<GbFlag />
							</button>
						</div>
						</div>
					</div>
					</div>
				</div>
				{/* ltn__header-middle-area end */}
				</header>
				<div id="ltn__utilize-mobile-menu" className="ltn__utilize ltn__utilize-mobile-menu">
				<div className="ltn__utilize-menu-inner ltn__scrollbar">
					<div className="ltn__utilize-menu-head">
					<div className="site-logo">
						<Link to="/"><img src={publicUrl+"assets/img/logo.png"} alt="Logo" /></Link>
					</div>
					<button className="ltn__utilize-close">×</button>
					</div>

					<div className="ltn__utilize-menu">
					<ul>
						<li><a href="/">{t('nav.home')}</a></li>
						<li><Link to="/about">{t('nav.about')}</Link></li>
						<li><Link to="/portfolio">{t('nav.photos')}</Link></li>
						<li><Link to="/portfoliov">{t('nav.videos')}</Link></li>
						<li><Link to="/contact">{t('nav.contact')}</Link></li>
						<br></br>
						<li className="special-link"><a href="https://api.whatsapp.com/send?phone=905520721972">{t('nav.reserve')}</a></li>
					</ul>
					<div className="roomy-lang-flags roomy-lang-flags--mobile">
						<button type="button" className={lang === 'tr' ? 'active' : ''} onClick={() => setLang('tr')} aria-label="Türkçe">
							<TrFlag />
						</button>
						<button type="button" className={lang === 'en' ? 'active' : ''} onClick={() => setLang('en')} aria-label="English">
							<GbFlag />
						</button>
					</div>
					</div>

				</div>
				</div>
			</div>
		)
    }
}


NavbarV2.contextType = LanguageContext;

export default NavbarV2
